(($) => {
  let action = true;
  const questionnaireForm = document.getElementById('questionnaire-form');

  if (questionnaireForm) {
    questionnaireForm.addEventListener('submit', function (e) {
      e.preventDefault();
      let formData = new FormData(questionnaireForm);

      var ins = document.getElementById('file').files.length;
      for (var x = 0; x < ins; x++) {
        formData.append("file[]", document.getElementById('file').files[x]);
      }

      

      const btnSubmit = questionnaireForm.querySelector('.msmLogin__btn');
      // console.table(Object.fromEntries(formData));      
      if (action) {
        action = false;
        $.ajax({
          url: my_ajax_object.ajaxurl,
          type: 'post',
          data: formData,
          contentType: false,
          processData: false,
          error: function (response) {
            // console.log(response);
          },
          beforeSend: function () {
            btnSubmit.classList.add('loading');
          },
          success: function (response) {
            const data = JSON.parse(response);
            console.log(data);
            // if (data.info === 'Error') {
            //   $(error).html(data.infoError);
            // } else {
            //   $(current).html(data.info);
            // }

            if (data.redirect) {
              setTimeout(() => {
                location.href = data.redirect;
              }, 700);
            }
            action = true;
          },
          complete: function(){
            btnSubmit.classList.remove('loading');
          },
        });
      }

    });

  }

})(jQuery);
